/* External */
import { makeFetchActionTypes } from "../../../utils";

export const baseActionName = "epg/filters";
export const actionTypes = makeFetchActionTypes(baseActionName);

export const setFilter = (filterId) => ({
  type: actionTypes.FETCH,
  payload: filterId
});
